import React, { createContext, useContext, useState, useEffect } from 'react';

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [sessionRole, setSessionRole] = useState(() => {
    // Intenta cargar rol del localStorage al iniciar
    const savedRole = localStorage.getItem('sessionRole');
    return savedRole || null;
  });
  
  const [sessionLanguage, setSessionLanguage] = useState(() => {
    // Obtener idioma del localStorage o usar default
    const savedLanguage = localStorage.getItem('sessionLanguage');
    if (savedLanguage) {
      console.log('📋 [SessionContext] Loaded sessionLanguage from localStorage:', savedLanguage);
      return savedLanguage;
    }
    
    // Si no existe en localStorage, obtener de i18nextLng (usado por i18n)
    const i18nLng = localStorage.getItem('i18nextLng');
    if (i18nLng) {
      console.log('📋 [SessionContext] Loaded sessionLanguage from i18nextLng:', i18nLng);
      return i18nLng;
    }
    
    // Default a español
    console.log('📋 [SessionContext] Using default language: es');
    return 'es';
  });

  // Guarda rol en localStorage cuando cambia
  useEffect(() => {
    if (sessionRole) {
      localStorage.setItem('sessionRole', sessionRole);
    } else {
      localStorage.removeItem('sessionRole');
    }
  }, [sessionRole]);

  // Guarda idioma en localStorage cuando cambia
  useEffect(() => {
    console.log('💾 [SessionContext] sessionLanguage changed:', sessionLanguage);
    localStorage.setItem('sessionLanguage', sessionLanguage);
  }, [sessionLanguage]);

  const clearSession = () => {
    setSessionRole(null);
    localStorage.removeItem('sessionRole');
  };

  return (
    <SessionContext.Provider 
      value={{ 
        sessionRole, 
        setSessionRole, 
        sessionLanguage, 
        setSessionLanguage,
        clearSession 
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession debe usarse dentro de SessionProvider');
  }
  return context;
};
